import { config } from '../config'
import { GetRecentContentLibrary, UpdateDocument } from '../types'
import { requests } from '../utils'

export const TemplateContentLibraryService = {
  addToContentLibrary: (params: UpdateDocument) => {
    return requests(config.PROPOSAL_SERVICE_URL).post(
      '/templates/content-library/add',
      params
    )
  },
  fetchRecentContentFromContentLibrary: (params: GetRecentContentLibrary) => {
    return requests(config.PROPOSAL_SERVICE_URL).get(
      '/templates/content-library/recent',
      {
        params,
      }
    )
  },
}
